import { useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import BenefitsSection from './components/BenefitsSection';
import ArticleTeaserSection from './components/ArticleTeaserSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://usfansspreadsheet.link';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Set canonical URL for homepage
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${SITE_URL}/`);
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = `${SITE_URL}/`;
      document.head.appendChild(link);
    }
  }, []);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'USFans Spreadsheet',
    url: SITE_URL,
    description: 'Kompletny przewodnik, aktualizacje i zasoby dotyczące USFans Spreadsheet. Poznaj najnowsze informacje, poradniki, porównania oraz praktyczne wskazówki.',
    inLanguage: 'pl',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'USFans Spreadsheet',
    url: SITE_URL,
    description: 'Kompleksowe źródło informacji o USFans Spreadsheet — przewodniki, poradniki, FAQ i zasoby dla użytkowników.',
    sameAs: [
      'https://kaspreadsheet.com/',
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Strona główna', item: `${SITE_URL}/` },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <BenefitsSection />
        <ArticleTeaserSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}